import {initSocialLinksSuggestionsDropdown} from "@Global/email-maker.tsx";

const DEFAULT_SOCIAL_IDs = ['facebook', 'instagram', 'x', 'pinterest'];
export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType(window.PMW.emails.styles.ID_SOCIAL_LINKS, {
        /**
         *
         * @param {object} props
         * @param {string} props.property
         * @param {grapesjs.Component} props.component
         * @param change
         * @return {ChildNode}
         */
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            const iconStyle = opt.editor.runCommand(window.PMW.emails.commands.GET_COMPONENT_STYLE, {component: props.component, property: 'icon-style'}) || 'original';

            const el = `<div class="js-social-links-box social-links-box">
                                    <div id="js-sortable-social-links" class="js-socials-container socials-container"></div>
                                    <div class="js-add-social-link add-social-buttons">
                                        <i class="icon-plus pmw-icon size-icon-16 content-body"></i>
                                    </div>
                                    <div class="links-dialog-container js-links-dialog-container"></div>
                                </div>`,
                elNodes = htmlToElements(el),
                elObj = $(elNodes),
                cacheKey = 'social-links-html-v3',
                selected = props.component;

            if (!selected) {
                return null;
            }

            PMW.onClick(elObj, '.js-social-link-item', function () {
                let t = $(this),
                    logoURL = t.attr('data-logo-url'),
                    baseURL = t.attr('data-base-url'),
                    id = t.attr('data-id'),
                    name = t.attr('data-name'),
                    type = t.attr('data-type'),
                    isDisabled = t.attr('disabled'),
                    platformURL = t.attr('data-placeholder');

                if (isDisabled) {
                    return;
                }

                $(elObj).find(`[data-name="${name}"]`).removeAttr('disabled').removeAttr('title');
                t.attr('disabled', 'true').attr('title', window.i18next.t('pmwjs_social_link_already_added'));

                addSocialLinkButtonHTML(elObj, selected, logoURL, baseURL, name, id, iconStyle, platformURL);
                addSocialLinkComponent(selected, logoURL, baseURL, name, id, type, platformURL);
            });

            PMW.onClick(elObj, '.js-add-social-link', function () {
                let dialog = elObj.find('.js-links-dialog-container');
                let addBtn = elObj.find('.add-social-buttons');
                addBtn.toggleClass('-open');
                dialog.toggleClass('-open');
            });

            if (PMW.getCacheItem(cacheKey)) {
                const dialogContainer = elNodes.querySelector('.js-links-dialog-container');
                const socialLinksDialog = getSocialLinksDialog(PMW.getCacheItem(cacheKey), iconStyle);
                dialogContainer.appendChild(socialLinksDialog);
                addDefaultLinks(selected, $(elNodes));
            } else {
                $.get(PMW.util.site_url('emailmaker/getSocialLinksURLs'), {}, function (r) {
                    if (r.status === 'success') {
                        PMW.setCacheItem(cacheKey, r.data.socialLinks);
                        const socialLinksDialog = getSocialLinksDialog(r.data.socialLinks, iconStyle);
                        const dialogContainer = elNodes.querySelector('.js-links-dialog-container');
                        dialogContainer.appendChild(socialLinksDialog);
                        addDefaultLinks(selected, $(elNodes));
                    }
                });
            }

            addExistingSocialLinksToStyleManager(elObj, selected, iconStyle);
            disableExistingLinksInDialog(selected, elObj.find('.js-links-dialog-container'));

            return elNodes;
        },
        emit({props}, {el, event, complete}) {
        },
        update({value, el}) {
        }
    });

    function getSocialLinksDialog(socialLinksData, iconStyle) {
        const HTTPS_PREFIX_LENGTH = 8;
        const socialLinkList = document.createElement('ul');
        socialLinkList.className = 'social-link-items-list bg-neutral-0 radius-8 spacing-p-3 border-s-standard';

        if (iconStyle === 'none') {
            iconStyle = 'original';
        }

        socialLinksData.forEach(socialLink => {
            const listItem = document.createElement('li');
            listItem.className = 'social-link-item js-social-link-item spacing-m-b-2 radius-8 bg-neutral-0 flexbox flex-content-start flex-items-start';
            listItem.setAttribute('data-id', socialLink.id);
            listItem.setAttribute('data-logo-url', socialLink.logos[iconStyle]);
            listItem.setAttribute('data-base-url', '');
            listItem.setAttribute('data-name', socialLink.name);

            let url = socialLink.baseURL;
            let placeholderURL = url.startsWith('https://') ? url.substring(HTTPS_PREFIX_LENGTH) : url;
            listItem.setAttribute('data-placeholder', placeholderURL)

            const img = document.createElement('img');
            img.className = 'social-link-img spacing-m-r-2';
            img.setAttribute('src', socialLink.logos[iconStyle]);
            img.setAttribute('alt', socialLink.name);

            const name = document.createElement('span');
            name.className = 'social-link-text body-xs content-body';
            name.textContent = socialLink.name;

            listItem.appendChild(img);
            listItem.appendChild(name)
            socialLinkList.appendChild(listItem);
        });

        return socialLinkList;
    }

    function disableExistingLinksInDialog(component, dialogContainer) {
        const existingImages = component.findType(window.PMW.emails.components.social.PMW_SOCIALS_IMAGE),
            existingLinkIds = existingImages.map(image => {
                const attributes = image.getAttributes() || {};
                return attributes['data-id'];
            });

        existingLinkIds.map(id => {
            dialogContainer.find(`.js-social-link-item[data-id="${id}"]`)
                .attr('disabled', 'true')
                .attr('title', window.i18next.t('pmwjs_social_link_already_added'))
        });
    }

    function addDefaultLinks(component, container) {
        const isEmpty = component.findType(window.PMW.emails.components.social.PMW_SOCIALS_ITEM).length === 0;
        if (isEmpty) {
            DEFAULT_SOCIAL_IDs.forEach(id => {
                const linkItem = container.find(`.js-social-link-item[data-id="${id}"]`)[0];
                if (linkItem) {
                    linkItem.click();
                }
            });
        }
    }

    function canAddSocialLinkComponent(component, name) {
        let imageIcons = component.findType(window.PMW.emails.components.social.PMW_SOCIALS_IMAGE),
            filteredIcons = imageIcons.filter(icon => {
                const attrs = icon.getAttributes() || {};
                return attrs['data-platform-name'] === name;
            });

        return filteredIcons.length === 0;
    }

    function canAddSocialLinkHTML(container, id) {
        return $(container).find(`.js-social-link-input[data-id="${id}"]`).length === 0;
    }

    function addExistingSocialLinksToStyleManager(elObj, component, iconStyle) {
        let socialIcons = component?.findType(window.PMW.emails.components.social.PMW_SOCIALS_IMAGE);
        socialIcons?.forEach(icon => {
            const attributes = icon.getAttributes(),
                id = attributes['data-id'],
                logoURL = attributes['data-logo-url'],
                baseURL = attributes['data-base-url'],
                platFormUrl = attributes['data-platform-url'],
                platformName = attributes['data-platform-name'];

            if (doesIconHaveInconsistentStyle(logoURL, iconStyle)) { // handle case for old social links with different IconStyles
                handleInconsistentIconStylesForOldSocialLinks();
            }
            addSocialLinkButtonHTML(elObj, component, logoURL, baseURL, platformName, id, iconStyle, platFormUrl);
        });
    }

    function addSocialLinkComponent(component, logoURL, baseURL, name, id, type, platformURL) {
        let editor = opt.editor,
            canAdd = canAddSocialLinkComponent(component, name),
            existingImage = component.find(`[data-platform-name="${name}"]`),
            newCompData = {
                type: window.PMW.emails.components.social.PMW_SOCIALS_IMAGE,
                stylable: true,
                removable: false,
                hoverable: false,
                selectable: false,
                draggable: false,
                highlightable: false,
                attributes: {
                    'src': logoURL,
                    'alt': name,
                    'data-platform-name': name,
                    'data-id': id,
                    'data-logo-url': logoURL,
                    'data-base-url': canAdd ? baseURL : existingImage[0].getAttributes()['data-base-url'],
                    'data-gjs-selectable': 'false',
                    'data-platform-url': platformURL,
                    'data-gjs-hoverable': 'false',
                }
            },
            socialPlatformImage = canAdd
                ? component.append(newCompData)[0]
                : existingImage[0].replaceWith(newCompData);

        // Tracking temporarily disabled on 8th Nov 2023
        // PMW.gtm.trackGA4CustomEvent('EmailMaker_SocialMediaLink', {[PMW.gtm.GA4_EVENT_PARAM_NAMES.SOCIAL_MEDIA_PLATFORM]: name});

        editor.runCommand(window.PMW.emails.commands.ADD_COMPONENT_ANCHOR, {
            component: socialPlatformImage,
            url: baseURL,
            customLinkComponent: window.PMW.emails.components.social.PMW_SOCIALS_ITEM
        });

        updateSocialLinkStyles(component);
    }

    function updateSocialLinkStyles(component) {
        let editor = opt.editor,
            style = component.getStyle();

        if (style && style['pmw-icon-margin']) {
            editor.runCommand(window.PMW.emails.commands.UPDATE_SOCIAL_LINK_SPACING, {gap: parseInt(style['pmw-icon-margin'])});
        }

        if (style && style['pmw-icon-size']) {
            editor.runCommand(window.PMW.emails.commands.UPDATE_SOCIAL_LINK_SIZE, {size: parseInt(style['pmw-icon-size'])});
        }
    }


    function createSortableLinkFields(container, selected) {
        Sortable.create(container.get(0), {
            selectedClass: "sortable-selected",
            handle: '.js-slide-dragger',
            onStart: function (evt) {
                triggerClickForSuggestionsDropdownClose(evt.item)
            },
            onEnd: function (evt) {
                let i = 0;

                selected.find(`[data-gjs-type="${window.PMW.emails.components.social.PMW_SOCIALS_ITEM}"]`).forEach((component) => {
                    if (i === evt.oldIndex) {
                        let parent = component.parent();
                        component.remove({temporary: true});
                        parent.append(component, {at: evt.newIndex});
                    }
                    i++;
                });

                evt.item.style.transform = '';
            },
        });
    }

    function triggerClickForSuggestionsDropdownClose(draggableContainer) {
        draggableContainer.click();
    }

    function addSocialLinkButtonHTML(elObj, selected, logoURL, baseURL, name, id, iconStyle, placeholder) {
        let container = elObj.find('.js-socials-container'),
            dialog = elObj.find('.js-links-dialog-container'),
            html = `<div class="js-draggable-social-link social-draggable-container">
                                <div class="social-link-input-container flex-column-justify-center">               
                                    <div class="flex-center spacing-p-t-2 spacing-p-b-2">
                                        <i class="pmw-icon js-slide-dragger icon-draggable social-link-drag-handler size-icon-16 spacing-m-r-2 spacing-m-l-0"></i>
                                        <div class="social-link-input-img-container"><img class="social-link-input-img ${iconStyle}" src="${logoURL}" alt="${name}"/></div>
                                        <div class="js-social-link-input flex-1" data-id="${id}"></div>
                                        <i class="pmw-icon icon-delete delete-icon js-delete-social-link size-icon-16 -square -ghost" data-id="${id}"></i>
                                    </div>
                                    <div class="error-message-container flexbox spacing-m-l-18 _hidden">
                                         <i class="pmw-icon icon-exclamation-triangle size-icon-16 _unmargin content-danger"></i>
                                         <span class="invalid-url-message body-xxs content-danger">${window.i18next.t('pmwjs_invalid_url')}</span>
                                    </div>
                                </div>
                            </div>`;

        dialog.addClass(iconStyle)
        if (canAddSocialLinkHTML(container, id)) {
            const newEl = document.createElement('div');
            newEl.innerHTML = html;
            container[0].appendChild(newEl);
            const inputElContainer = newEl.querySelector(`.js-social-link-input[data-id="${id}"]`);
            renderSocialLinkInputSuggestionsDropdown(inputElContainer, id, baseURL, placeholder);
        } else {
            const existingInputEl = $(container).find(`.js-social-link-input[data-id="${id}"]`).find('input');

            if (existingInputEl.length !== 0) {
                const existingURL = existingInputEl.val();
                const updatedHtml = html.replace(baseURL, existingURL.toString());
                existingInputEl.parents('.js-draggable-social-link').replaceWith(updatedHtml);
            }
        }

        if (!container.attr('data-init')) {
            container.attr('data-init', 1);

            PMW.onClick(container, '.js-delete-social-link', function () {
                let t = $(this),
                    id = t.attr('data-id');

                selected.find(`[data-gjs-type="${window.PMW.emails.components.social.PMW_SOCIALS_IMAGE}"][data-id="${id}"]`).forEach(component => {
                    component.parent().remove();
                });

                t.parents('.js-draggable-social-link').remove();
                dialog.find(`[data-id="${id}"]`).removeAttr('disabled')
                    .removeAttr('title');
            });

            if (typeof Sortable === 'undefined') {
                PMW.getJsAssetGroup('sortableLib', function () {
                    createSortableLinkFields(container, selected);
                });
            } else {
                createSortableLinkFields(container, selected);
            }
        }
    }

    /**
     * Added for fixing inconsistent styles for social icons in existing templates before UI update
     *
     * @returns void
     * @param {HTMLElement} contentContainer HTML container that will contain the React Component for social links suggestions
     * @param {string} id Id for input element that corresponds to Social platform name the input is for
     * @param {string} inputValue value for the input element
     * @param {string} inputPlaceholder placeholder for the input element
     */

    function renderSocialLinkInputSuggestionsDropdown(contentContainer, id, inputValue, inputPlaceholder) {
        const socialLinkInputCustomHandlers = {
            onInputFocus: onCustomInputFocus,
            onInputBlur: onCustomInputBlur,
        }

        const dropdownOpts = {
            platform: id,
            socialLinkInputCustomHandlers: socialLinkInputCustomHandlers,
            inputFieldProps: {
                inputClassName: 'social-link-input-url js-social-link-input-url border-s-darker radius-4 body-xxs content-body spacing-m-r-1',
                placeholder: inputPlaceholder || window.i18next.t('pmwjs_add_profile_url'),
                input: inputValue,
                size: 'XSMALL',
            },
            inputSuggestionsDropdownProps: {
                popupClassName: 'social-link-suggestions-dropdown',
                popupAlignment: 'bottom-end',
                popupPosition: 'FIXED',
                truncateText: true,
                showSuggestionAsTitleOnHover: true,
            }
        }

        initSocialLinksSuggestionsDropdown(contentContainer, dropdownOpts)
    }

    /**
     *
     * @returns void
     * @param {jQuery} urlContainer
     * @param {boolean} showError
     */
    function doShowInvalidUrlMessage(urlContainer, showError) {
        if (!urlContainer) {
            return;
        }

        const socialLinkContainer = urlContainer.closest('.social-link-input-container');
        const invalidUrlMessage = socialLinkContainer.find('.error-message-container');

        if (showError) {
            invalidUrlMessage.removeClass('_hidden');
            urlContainer.addClass('-error');
        } else {
            invalidUrlMessage.addClass('_hidden');
            urlContainer.removeClass('-error');
        }
    }

    /**
     * Added for fixing inconsistent styles for social icons in existing templates before UI update
     *
     * @returns boolean
     * @param {string} logoURL
     * @param {string} iconStyle
     */
    function doesIconHaveInconsistentStyle(logoURL, iconStyle) {
        const logoUrlParts = logoURL.split('/social-icons/');
        if (logoUrlParts.length > 1) {
            const iconPath = logoUrlParts[1];
            const iconDirectory = iconPath.split('/')[0];

            if (iconDirectory !== iconStyle) {
                return true;
            }
        }

        return false
    }

    function handleInconsistentIconStylesForOldSocialLinks() {
        opt.editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {component: editor.getSelected(), property: 'icon-style', value: 'none'});
    }

    /**
     *
     * @param {string} html
     * @returns {HTMLElement}
     */
    function htmlToElements(html) {
        const template = document.createElement('template');
        template.innerHTML = html;
        return template.content.childNodes[0];
    }

    /**
     * Custom onInputFocus passed to React InputField component that hides the invalid URL error state on focus
     *
     * @returns void
     * @param {string} dataId data-id attribute of the Input el and its corresponding social link icon in the email template
     * @param {string} value input value
     */
    function onCustomInputFocus(dataId, value) {
        const inputElContainer = $(`.js-social-link-input[data-id="${dataId}"]`).find('input');
        doShowInvalidUrlMessage(inputElContainer, false);
    }

    /**
     * Custom onInputBlur passed to React InputField component that takes the new input value
     * and updates the href for the social link icon in the email template
     *
     * @returns void
     * @param {string} dataId data-id attribute (social platform) of the Input el and its corresponding social link icon in the email template
     * @param {string} value URL entered for the input
     */
    function onCustomInputBlur(dataId, value) {
        const inputElContainer = $(`.js-social-link-input[data-id="${dataId}"]`).find('input');
        let url = getSanitizedUrl(value.trim());

        if (url === '' || editor.runCommand(window.PMW.emails.commands.IS_VALID_FOR_LINK, {url: url})) {
            doShowInvalidUrlMessage(inputElContainer, false);
        } else {
            doShowInvalidUrlMessage(inputElContainer, true);
            return;
        }

        const urlHasHttps = getUrlHasHttps(url);
        const isUrlEmail = isValidEmail(url);
        const emailHasMailTo = getEmailHasMailTo(url);
        const urlNeedsUpdate = url && (!urlHasHttps && !emailHasMailTo);


        if (isUrlEmail && !emailHasMailTo) {
            url = addMailToToEmail(url);
        } else if (url && !urlHasHttps && !isUrlEmail) {
            url = addHttpsToUrl(url);
        }

        if (urlNeedsUpdate) {
            updateInputValueForSocialLinkInputElement(inputElContainer, url);
        }

        editor.getSelected().find(`[data-gjs-type="${window.PMW.emails.components.social.PMW_SOCIALS_IMAGE}"][data-id="${dataId}"]`)
            .forEach(component => {
                const currentBaseUrl = component.getAttributes()['data-base-url'];
                const hasUrlUpdated = currentBaseUrl !== url;

                if (!hasUrlUpdated) {
                    return;
                }

                component.addAttributes({'data-base-url': url});
                component.parent().addAttributes({
                    'href': url,
                    'data-url': url,
                    'data-base-url': url
                });
            });


    }

    const updateInputValueForSocialLinkInputElement = (inputEl, url) => {
        if (!inputEl) {
            return;
        }

        inputEl.val(url);
    }

    const getSanitizedUrl = (url) => {
        url = decodeURI(url);
        url = encodeURI(url);
        return url;
    }

    const addHttpsToUrl = (url) => {
        return `https://${url}`;
    };

    const addMailToToEmail = (url) => {
        return `mailto:${url}`;
    };

    const getUrlHasHttps = (url) => {
        return /^[a-zA-Z]+:\/\//.test(url)
    }

    const getEmailHasMailTo = (url) => {
        return url.startsWith('mailto:');
    }

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
}
